/**
 * 视频缩略图生成 — 从视频首帧绘制到 canvas
 * 复用自 player.html 的 loadThumbnail 逻辑
 */

const thumbnailCache = new Map<string, boolean>();

export function useVideoThumbnails() {
  function loadThumbnail(canvas: HTMLCanvasElement, videoUrl: string): void {
    if (thumbnailCache.has(videoUrl)) return;
    thumbnailCache.set(videoUrl, true);

    // 创建临时 video 元素
    const tmp = document.createElement('video');
    tmp.muted = true;
    tmp.preload = 'auto';
    tmp.playsInline = true;
    tmp.crossOrigin = 'anonymous';

    function onSeek() {
      tmp.removeEventListener('seeked', onSeek);
      try {
        canvas.width = tmp.videoWidth || 320;
        canvas.height = tmp.videoHeight || 180;
        canvas.getContext('2d')?.drawImage(tmp, 0, 0, canvas.width, canvas.height);
      } catch {
        // 跨域或解码失败，留空背景
      } finally {
        tmp.src = '';
        tmp.load();
      }
    }

    // 在 0.1s 处捕获第一帧
    tmp.addEventListener('loadeddata', function onLoaded() {
      tmp.removeEventListener('loadeddata', onLoaded);
      try {
        tmp.currentTime = 0.1;
      } catch {
        tmp.currentTime = 0;
      }
    });

    tmp.addEventListener('seeked', onSeek);

    // 超时保护：3 秒后放弃
    setTimeout(() => {
      try { tmp.removeEventListener('seeked', onSeek); } catch { /* noop */ }
      tmp.src = '';
      tmp.load();
    }, 3000);

    tmp.src = videoUrl;
  }

  function clearCache(): void {
    thumbnailCache.clear();
  }

  return { loadThumbnail, clearCache };
}
